import { defineStore } from 'pinia';

export const useWindowSizeStore = defineStore('windowSize', {
	state: () => ({
		width: window.innerWidth,
		_initialized: false,
	}),
	actions: {
		init() {
			if(this._initialized) return;
			this._initialized = true;
			window.addEventListener('resize', () => {
				this.width = window.innerWidth;
			}, { passive: true });
		},
	},
});
